module.exports = __webpack_public_path__ + "img/discord-wordmark.c97c4b07.svg";